import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import cn from 'classnames';
import i18n from 'i18next';
import useSWR from 'swr';
import api, {getURL} from '../../../api';
import {EXTRA_FORM_NAMES, FORM_NAMES} from '../../AddPersonalDataForm/types';
import {getLocationsAsOptions} from '../../AddPersonalDataForm/AddPersonalDataForm';
import {useTranslation} from 'react-i18next';
import Select from '../FieldSelect';
import styles from './styles.module.sass';
import {FormFieldWrapper} from '../../../styled/common';

export type IdentityTypeSelectorProps = {
  title: string;
  displayFields: Partial<Record<FORM_NAMES | EXTRA_FORM_NAMES, boolean>>;
};

function IdentityForm({title, displayFields}: IdentityTypeSelectorProps) {
  const {t} = useTranslation();
  const {control} = useFormContext();

  const language = i18n.language;
  const {data: locations, mutate: revalidateLocations} = useSWR(
    getURL(api.locations.ENDPOINTS.get('ordering=name')),
  );
  const locationsAsOptions = React.useMemo(() => {
    return getLocationsAsOptions(locations);
  }, [locations]);

  React.useEffect(
    function handleLanguageChange() {
      revalidateLocations();
    },
    [language, revalidateLocations],
  );

  return (
    <div className={cn(styles.wrapper, styles.formWrapper)}>
      <div className={styles.title}>{title}</div>
      <div className={styles.fieldsList}>
        <Controller
          name={FORM_NAMES.nationality}
          rules={{required: t('required') as string}}
          control={control}
          render={({field, fieldState: {error}}) => (
            <Select
              label={t('nationality')}
              options={locationsAsOptions}
              placeholder={t('select')}
              error={error?.message}
              {...field}
            />
          )}
        />
        {displayFields[FORM_NAMES.residenceCountry] && (
          <Controller
            name={FORM_NAMES.residenceCountry}
            rules={{required: true}}
            control={control}
            render={({field, fieldState: {error}}) => (
              <Select
                label={t('residence_country')}
                options={locationsAsOptions}
                placeholder={t('select')}
                error={error?.message}
                {...field}
              />
            )}
          />
        )}
        {displayFields[FORM_NAMES.citizenship] && (
          <FormFieldWrapper>
            <Controller
              name={FORM_NAMES.citizenship}
              rules={{required: true}}
              control={control}
              render={({field, fieldState: {error}}) => (
                <Select
                  label={t('citizenship')}
                  options={locationsAsOptions}
                  placeholder={t('select')}
                  error={error?.message}
                  {...field}
                />
              )}
            />
          </FormFieldWrapper>
        )}
      </div>
    </div>
  );
}

export {IdentityForm};
